import{ButtonIconStyle as o,ButtonIconPosition as n}from"../constants/index.js";const e=t=>t?{position:n.left,style:o.simple,...t}:null;export{e as prepareIconProps};
